import React from "react";
import { createPortal } from "react-dom";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ALERT_IMAGE from "../../../assets/images/modal_top_image.png";

interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  overflowUnset?: boolean;
  actions?: React.ReactNode;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  showLine?:boolean
}

export const Modal: React.FC<ModalProps> = ({
  children,
  actions,
  title,
  onClose,
  overflowUnset = false,
  onSubmit,
  showLine
}) => {
  const modalRoot = document.getElementById("root");

  if (!modalRoot) {
    console.error("Modal root element not found");
    return null;
  }

  const scrollContainerClass = [
    "bg-white",
    "mx-auto",
    "rounded-xl",
    "min-h-[150px]",
    "min-w-[400px]",
    "max-w-full",
    "max-h-screen",
    "z-[50]",
    !overflowUnset && "overflow-auto",
  ].join(" ");

  return createPortal(
     <div className="fixed inset-0 flex h-[1500vh] items-start justify-center bg-black bg-opacity-60 w-full transition-opacity z-40">
      <div className="flex flex-col w-full max-w-[90%] sm:max-w-[633px] px-2 py-2 relative mt-4">
        <div id="modal-popup-container" />
        <div className={scrollContainerClass}>
          {/* Top Image */}
          <div className="w-full h-[23px]">
            <img
              src={ALERT_IMAGE}
              alt="Modal header decoration"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Header */}
          <div className="flex items-center justify-between h-auto px-6 py-6 gap-2">
            <h2
              className="flex-1 font-arial text-[24px] font-bold leading-[36px] text-left text-[#002B6E] normal-case tracking-normal"
              data-testid="modal-title"
            >
              {title}
            </h2>
            <button
              onClick={onClose}
              className="w-[24px] h-[24px] flex items-center justify-center"
              aria-label="Close modal"
              type="button"
            >
              <CloseOutlinedIcon />
            </button>
          </div>

          {/* Body & Actions */}
          <form onSubmit={onSubmit}>
            <div
              className="w-full h-auto px-0 py-6"
              data-testid="modal-body"
            >
              {/* Modal content */}
              <div className="mt-2 font-arial text-[16px] font-normal leading-[28px] text-left">
                {children}
              </div>
              {/* Line */}
              {showLine &&<div
                className="mt-4 w-full h-auto px-0 py-6 gap-0 border-b border-[#CED0D5]"
                data-testid="modal-content"
              ></div>}

              {/* Modal actions */}
              {actions && (
                <div className="w-full h-auto flex flex-row justify-end items-center">
                  <div className="flex flex-row items-center px-6 pt-6">{actions}</div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>,
    modalRoot
  );
};